import React, { useMemo } from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
  ResponsiveContainer,
  Legend,
} from "recharts";

const PatientChart = ({ data }) => {
  const chartData = useMemo(() => {
    if (!Array.isArray(data)) return [];

    const grouped = {};

    data.forEach((item) => {
      if (!item.createdAt) return;

      const date = new Date(item.createdAt).toLocaleDateString("en-CA");

      if (!grouped[date]) {
        grouped[date] = {
          name: date,
          totalPatients: 0,
        };
      }

      grouped[date].totalPatients += 1;
    });

    return Object.values(grouped).sort(
      (a, b) => new Date(a.name) - new Date(b.name),
    );
  }, [data]);

  if (!chartData.length) {
    return <p style={{ textAlign: "center" }}>No data available</p>;
  }

  return (
    <ResponsiveContainer width="100%" height={300}>
      <LineChart data={chartData}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="name" />
        <YAxis />
        <Tooltip />
        <Legend />

        <Line
          type="monotone"
          dataKey="totalPatients"
          stroke="#8884d8"
          name="Total Patients"
        />
      </LineChart>
    </ResponsiveContainer>
  );
};

export default PatientChart;
